// types of actions to dispatch for Support page.
export const SupportActionTypes = {
    ENTER_WSID: "SETTING_WSID",
    REGION_SELECTED: "API_REGION_SELECTED",
    GET_TX_LOGS: "GET_TX_LOGS",
    LOAD_TX_LOGS: "LOAD_TX_LOGS",
    GET_DEBUG_FILES: "GET_DEBUG_FILES",
    LOAD_DEBUG_FILES: "LOAD_DEBUG_FILES",
    DISPLAY_TX_LOGS: "DISPLAYING_TX_LOGS_MODAL",
    DISPLAY_DEBUG_FILES: "DISPLAYING_DEBUG_FILES_MODAL",
    CLOSE_TX_MODAL: "CLOSE_TX_MODAL",
    CLOSE_DEBUG_MODAL: "CLOSE_DEBUG_MODAL",
    CLEAR_TX_DEBUG_DETAILS: "CLEAR_TX_DEBUG_DETAILS",
};

export const TestcacheActionTypes = {
    // TESTCACHE CONSTANTS
    CLEAR_TESTCACHE_DETAILS: "CLEAR_TESTCACHE_DETAILS",
    FILTER_TESTCACHE_RECORDS: "FILTER_TESTCACHE_RECORDS",
    SET_TESTCACHE_FILTER: "SET_TESTCACHE_FILTER",
    ALL_TESTCACHE_SELECTED: "ALL_TESTCACHE_RECORDS_SELECTED",
    SOME_TESTCACHE_SELECTED: "SOME_TESTCACHE_RECORDS_SELECTED",
    TOGGLE_ADD_TESTCACHE_MODAL: "TOGGLE_ADD_TESTCACHE_MODAL",
    TOGGLE_EDIT_TESTCACHE_MODAL: "TOGGLE_EDIT_TESTCACHE_MODAL",
    OPEN_EDIT_TESTCACHE_MODAL: "OPEN_EDIT_TESTCACHE_MODAL",
    SETTING_TESTCACHE_FORM_OBJECT_VALUE: "SETTING_TESTCACHE_FORM_OBJECT_VALUE",
    LOAD_SOURCE_TYPES: "LOAD_SOURCE_TYPES_TESTCACHE",
    SET_DATE_OF_BIRTH: "SET_DATE_OF_BIRTH_TESTCACHE",
    SET_COUNTRY: "SET_COUNTRY_FOR_TESTCACHE",
    SET_SOURCE_TYPE: "SET_SOURCE_TYPE_FOR_TESTCACHE",
    GENERATE_POSTMAN_REQUEST: "GENERATE_POSTMAN_REQUEST",
}

export const apiActionsTestcache = {
    SET_TESTCACHE_DB_TABLE_DATA: "SET_TESTCACHE_DB_TABLE_DATA",
    GET_ALL_TESTCACHE: "GET_ALL_TESTCACHE",
    ADD_TO_TESTCACHE: "ADD_TO_TESTCACHE",
    EDIT_TESTCACHE: "EDIT_TESTCACHE",
    DELETE_TESTCACHE: "DELETE_TESTCACHE",
    DELETE_WARNING_FOR_TESTCACHE: "DELETE_WARNING_FOR_TESTCACHE",
}

// KYB Testcache Action Types
export const KYBTestcacheActionTypes = {
    CLEAR_KYB_TESTCACHE_DETAILS: "CLEAR_KYB_TESTCACHE_DETAILS",
    FILTER_KYB_TESTCACHE_RECORDS: "FILTER_KYB_TESTCACHE_RECORDS",
    SET_KYB_TESTCACHE_FILTER: "SET_KYB_TESTCACHE_FILTER",
    ALL_KYB_TESTCACHE_SELECTED: "ALL_KYB_TESTCACHE_RECORDS_SELECTED",
    SOME_KYB_TESTCACHE_SELECTED: "SOME_KYB_TESTCACHE_RECORDS_SELECTED",
    TOGGLE_ADD_KYB_TESTCACHE_MODAL: "TOGGLE_ADD_KYB_TESTCACHE_MODAL",
    TOGGLE_EDIT_KYB_TESTCACHE_MODAL: "TOGGLE_EDIT_KYB_TESTCACHE_MODAL",
    OPEN_EDIT_KYB_TESTCACHE_MODAL: "OPEN_EDIT_KYB_TESTCACHE_MODAL",
    SETTING_KYB_TESTCACHE_FORM_OBJECT_VALUE: "SETTING_KYB_TESTCACHE_FORM_OBJECT_VALUE",
    LOAD_KYB_SOURCE_TYPES: "LOAD_KYB_SOURCE_TYPES_TESTCACHE",
    SET_KYB_COUNTRY: "SET_COUNTRY_FOR_KYB_TESTCACHE",
    SET_KYB_SOURCE_TYPE: "SET_SOURCE_TYPE_FOR_KYB_TESTCACHE",
    GENERATE_KYB_POSTMAN_REQUEST: "GENERATE_KYB_POSTMAN_REQUEST",
}

// KYB Testcache API Action Types
export const apiActionsKYBTestcache = {
    SET_KYB_TESTCACHE_TABLE_DATA: "SET_KYB_TESTCACHE_TABLE_DATA",
    GET_ALL_KYB_TESTCACHE: "GET_ALL_KYB_TESTCACHE",
    ADD_TO_KYB_TESTCACHE: "ADD_TO_KYB_TESTCACHE",
    EDIT_KYB_TESTCACHE: "EDIT_KYB_TESTCACHE",
    DELETE_KYB_TESTCACHE: "DELETE_KYB_TESTCACHE",
    DELETE_WARNING_FOR_KYB_TESTCACHE: "DELETE_WARNING_FOR_KYB_TESTCACHE",
}

